import { render, staticRenderFns } from "./AppGDPR.vue?vue&type=template&id=1399bc70"
import script from "./AppGDPR.vue?vue&type=script&lang=ts"
export * from "./AppGDPR.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports